import React from 'react';
import { FlowRender } from "../flow-render";
import { Name } from "../prm/name";
import {has_joint_role, is_custodial} from "../onboarding-utils";
import { Action } from "../../client/funcs/utils";
import {deep_copy} from "../js-utils";
import {Slider} from "../prm/slider"
import "rc-slider/assets/index.css";
import {getRGB} from "../color";

const role_0_income = new Slider(new Name("role_0_income"), 0, 250000, 1000, 0, true);
const role_0_net_worth = new Slider(new Name("role_0_net_worth"), 0, 1000000, 1000, 0, true);

// Data for an investment account setting.
const INVESTMENT_ONBOARDING = {
  invest_for: [ "invest_for|standard_invest_0" ],
  invest_type: "individual",
}

class NetWorth extends FlowRender {

  constructor(index) {
    super(index, [
      role_0_income,
      role_0_net_worth,
    ]);

    role_0_income.onChangeCallback = this.onChange;
    role_0_net_worth.onChangeCallback = this.onChange;
    this.url = "net_worth";
  }

  init(componentState, appState) {
    super.init(componentState, appState);
    componentState.over_income_cap = false;
    componentState.loading = false;
  }

  onMount(component) {
    component.maybeLoadGovernor();
  }

  onChange = (component, newState) => {
  }

  canNavigateNext(component) {

    if (component.state.over_income_cap) {
      return null;
    }

    if (!component.isBaseAcct()) {
      return component.getRootUrl() + "/authorization_0";
    }
    return component.getRootUrl() + "/identification";
  }

  maybeRenderIncomeCap = component => {
    if (!component.state.over_income_cap) {
      return null;
    }

    const text =
      "Your income is too high, and unfortunately, the IRS will not allow you to open a ROTH IRA. "
      + "Would you like us to open a regular taxable investment account for you?";

    const div_style = {
      paddingTop: "1rem",
      margin: "auto",
      width: "80%",
    };

    const no_cb = () => {
      const new_state = deep_copy(component.state);
     //role_0_income.clear(new_state);
      this.onChange(component, new_state);
      component.setState(new_state);
    }

    const yes_cb = () => {
      component.props.dataToStore(
        INVESTMENT_ONBOARDING, component.getOnboardingIndex(),
        component.props.username);
      component.setState({ loading: true });
      component.props.dataToDynamo(
        INVESTMENT_ONBOARDING, component.getOnboardingIndex(), () => {
          const new_state = deep_copy(component.state);
          new_state.loading = false;
          this.onChange(component, new_state);
          component.setState(new_state);
        }, false, component.props.username, component.props.identity_id );
    }

    return (
      <div>
        <div>{text}</div>
        <div style={div_style}>
          <Action
            text={"Yes"}
            style={{marginRight: "1rem"}}
            onClick={yes_cb}>
            Yes
          </Action>
          <Action onClick={no_cb}>
            No
          </Action>
        </div>
      </div>
    )
  }

  render = component => {
    const onboarding = component.getOnboardingData();
    const has_joint = has_joint_role(onboarding);
    const container_style = {
      width: has_joint ? "60%" : "50%",
      margin: "auto",
    };
    const client = component.props.client;


    const annualIncomeText = "Your Annual Income (usually your yearly all in salary)"
    const approxNetWorthText = "Your approximate Net Worth not including your primary residence (usually all your assets minus all your debts)"
    // const slider_styles = {
    //     // Styles for the handle
    //     handle: {
    //       borderColor: 'black',
    //       height: 24,
    //       width: 24,
    //       transform: 'translate(0, -50%)',
    //     //   marginLeft: -12,
    //     //   marginTop: -9,
    //       backgroundColor: getRGB(client.color.sign_on_button),
    //     },
    //     // Styles for the track
    //     track: {
    //       backgroundColor: getRGB(client.color.sign_on_button),
    //       height: 6,
    //     },
    //     // Styles for the rail
    //     rail: {
    //       backgroundColor: getRGB(client.color.sign_on_button),
    //       height: 6,
    //     },
    //   };
    const slider_styles = {
        handle: {
            backgroundColor: getRGB(client.color.sign_on_button)
        },
        track: {
            backgroundColor: getRGB(client.color.sign_on_button),
        },
        rail: {
            backgroundColor: getRGB(client.color.sign_on_button),
        }
    };
    let title = "Income and Net Worth";
    if (is_custodial(onboarding)) {
      title += " of the Minor";
    }
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, title, "50%", "952139637")}
        { this.renderProgress(component) }
        <section style={{paddingTop: "1rem"}}>
          <div className="divgrid-container-responsive" style={container_style}>
            <div style={{height: "1rem"}}/>
            <div>
            {role_0_income.renderSlider(component, slider_styles, annualIncomeText)}
            {role_0_net_worth.renderSlider(component, slider_styles, approxNetWorthText)}
          </div>
          </div>
        </section>
        { this.renderNextButtonRow(component, true) }
      </div>
    );
  }
}

export { NetWorth, role_0_income, role_0_net_worth };
